'use client';

// IMPORTANT: keep this as the first import.
// Under App Router, the server and client bundles have separate module
// graphs. The `import 'lib/preload'` in `app/layout.tsx` only affects the
// server bundle — the client bundle has its own copy of `tailwind-variants`
// and would otherwise default to `twMerge: true`, which drops our custom
// Figma-token classes (`text-white`, `border-general-border-width-button`,
// etc.). Importing preload from this client-side root ensures
// `defaultConfig.twMerge = false` runs in the client bundle too, before any
// component's module-level `tv()` call evaluates.
import 'src/lib/preload';

import {
  ComponentPropsCollection,
  ComponentPropsContext,
  Page,
  SitecoreProvider,
} from '@sitecore-content-sdk/nextjs';
import components from '.sitecore/component-map';
import scConfig from 'sitecore.config';
import { SearchInitializationProvider } from 'lib/context/SearchInitializationContext';
import { SitecoreSearchWidgetsProviderWrapper } from 'widgets/WidgetProviderWrapper';

const loadImportMap = () => import('.sitecore/import-map.client');

const Providers = ({
  children,
  componentProps,
  page,
}: {
  children: React.ReactNode;
  componentProps?: ComponentPropsCollection;
  page: Page;
}) => {
  return (
    <ComponentPropsContext value={componentProps || {}}>
      <SitecoreProvider
        componentMap={components}
        api={scConfig.api}
        page={page}
        loadImportMap={loadImportMap}
      >
        <SearchInitializationProvider
          siteName={page.siteName || scConfig.defaultSite}
          contextId={scConfig.api?.edge?.clientContextId}
        >
          <SitecoreSearchWidgetsProviderWrapper>
            {children}
          </SitecoreSearchWidgetsProviderWrapper>
        </SearchInitializationProvider>
      </SitecoreProvider>
    </ComponentPropsContext>
  );
};

export default Providers;
